<script setup lang="ts">
import Icon from '../../shared/Icon.vue'

export type RecipeInterlineVariant = 'ingredients' | 'instruction' | 'nutrition'

withDefaults(defineProps<{
  title?: string,
  variant?: RecipeInterlineVariant
}>(), {
  variant: 'ingredients'
})
</script>

<template>
  <h2 class="bx-recipe__interline">
    <Icon v-if="variant"
          :name="variant" />
    <span>{{ title }}</span>
  </h2>
</template>
